module.exports = __webpack_public_path__ + "0e4eaabf8f668c922f676fe07cbeaeaf.svg";